import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FileItem from './FileItem';
import styles from '../styles.module.scss';

export function FilesList({
                                    shumaID,
                                    files = [],
                                  }) {
  const mapFiles = file => {
    const {
      fileID,
      fileName,
      fileExtension,
      fileTypeName
    } = file;

    return (
      <FileItem
        shumaID={shumaID}
        fileID={fileID}
        fileName={fileName}
        fileTypeName={fileTypeName}
        fileExtension={fileExtension}
      />
    );
  };

  return (
    <div className={styles.filesListHeaderContainer}>
      <div className={classnames(styles.headers, {[styles.headersOffset]: files.length > 5})}>
        <div className={styles.headersItem}>שם הקובץ</div>
        <div className={styles.headersItem}>סוג</div>
        <div className={styles.headersItem}>הורדה</div>
      </div>
      <div className={styles.gridBody}>
        {files.map(mapFiles)}
      </div>
    </div>
  );

}

FilesList.propTypes = {
  shumaID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  files: PropTypes.array
};
